import { AxiosPromise } from "axios";
import service from "../apis/Service";
import DtoSelectSearchParamFbaWarehouseCode from "../models.machine/DtoSelectSearchParamFbaWarehouseCode";
import RESTfulResult from "../models.machine/RESTfulResult";
import UiSelectOption from "../models.machine/UiSelectOption";
import DtoPageListSearchParamFbaWarehouseCode from "../models.machine/DtoPageListSearchParamFbaWarehouseCode";
import DtoPageListParamFbaWarehouseCode from "../models.machine/DtoPageListParamFbaWarehouseCode";
import UiDrag from "../models.machine/UiDrag";
import DtoDetailParamFbaWarehouseCode from "../models.machine/DtoDetailParamFbaWarehouseCode";
import DtoFormParamFbaWarehouseCode from "../models.machine/DtoFormParamFbaWarehouseCode";

/**
 * FBA仓库代码
 * @description 自动生成的代码,请勿修改
 */
export default class ParamFbaWarehouseCodeAppService {
    /**
     * 获取FBA仓库代码选择器
     * @param {DtoSelectSearchParamFbaWarehouseCode} [search] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<UiSelectOption<string>[]>>} 选择器
     */
    static GetSelect(search?: DtoSelectSearchParamFbaWarehouseCode): AxiosPromise<RESTfulResult<UiSelectOption<string>[]>> {
        const url = `/api/ParamFbaWarehouseCode/GetSelect`;
        return service.get<RESTfulResult<UiSelectOption<string>[]>>(url, { params: search });
    }

    /**
     * 获取分页列表
     * @param {DtoPageListSearchParamFbaWarehouseCode} [dto] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<DtoPageListParamFbaWarehouseCode>>} 分页列表
     */
    static Get(dto?: DtoPageListSearchParamFbaWarehouseCode): AxiosPromise<RESTfulResult<DtoPageListParamFbaWarehouseCode>> {
        const url = `/api/ParamFbaWarehouseCode/Get`;
        return service.get<RESTfulResult<DtoPageListParamFbaWarehouseCode>>(url, { params: dto });
    }

    /**
     * 拖曳排序
     * @param {UiDrag<string>} [dto] 传参
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static DragSort(dto?: UiDrag<string>): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamFbaWarehouseCode/DragSort`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 获取FBA仓库代码详细
     * @param {string} [id] Id
     * @returns {AxiosPromise<RESTfulResult<DtoDetailParamFbaWarehouseCode>>} 详细
     */
    static GetById(id?: string): AxiosPromise<RESTfulResult<DtoDetailParamFbaWarehouseCode>> {
        const url = `/api/ParamFbaWarehouseCode/Get/${id}`;
        return service.get<RESTfulResult<DtoDetailParamFbaWarehouseCode>>(url);
    }

    /**
     * 新增/编辑FBA仓库代码
     * @param {DtoFormParamFbaWarehouseCode} [dto] 表单
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Post(dto?: DtoFormParamFbaWarehouseCode): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamFbaWarehouseCode/Post`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 批量删除FBA仓库代码
     * @param {string[]} [ids] Id
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Delete(ids?: string[]): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamFbaWarehouseCode/Delete`;
        return service.delete<RESTfulResult<any>>(url, { data: ids });
    }

    /**
     * 同步
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static SyncData(): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamFbaWarehouseCode/SyncData`;
        return service.post<RESTfulResult<any>>(url);
    }

    /**
     * 导出
     * @param {string} [name] 
     * @returns {AxiosPromise<RESTfulResult<string>>} 
     */
    static GetExportExceByName(name?: string): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/ParamFbaWarehouseCode/GetExportExce/${name}`;
        return service.get<RESTfulResult<string>>(url);
    }

}
